const LAUNCH=Date.parse('2026-10-02T20:00:00+01:00');
const VISITOR='sc-activity-visitor-v1',SESSION='sc-activity-session-v1',PICK='sc-activity-picked-v1',PENDING='sc-activity-pending-v1';
const configNode=document.getElementById('sc-activity-config');
let config;
try{config=JSON.parse(configNode?.textContent||'null');}catch{}
if(config?.endpoint && !window.Shopify?.designMode && (!navigator.webdriver || window.Shopify?.theme?.role !== 'main')){
 const sandbox=window.Shopify?.theme?.role!=='main';
 const suffix=sandbox?'-preview':'';
 let sendingPick=false,started=false;
 const permitted=()=>window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()===true;
 function identity(){
  let visitor=localStorage.getItem(VISITOR);
  if(!visitor){visitor=crypto.randomUUID();localStorage.setItem(VISITOR,visitor);}
  let session;try{session=JSON.parse(localStorage.getItem(SESSION)||'null');}catch{}
  if(!session||Date.now()-session.seen>1800000)session={id:crypto.randomUUID()};
  session.seen=Date.now();localStorage.setItem(SESSION,JSON.stringify(session));
  return {visitor,session:session.id};
 }
 async function send(kind){
  if(!permitted()||document.prerendering)return false;
  try{
   const ids=identity();
   const response=await fetch(config.endpoint,{method:'POST',credentials:'omit',headers:{'Content-Type':'application/json'},
    body:JSON.stringify({...ids,kind,consent:true,sandbox}),signal:AbortSignal.timeout(5000),keepalive:true});
   return response.ok&&(await response.json()).accepted===true;
  }catch{return false;}
 }
 async function pick(){
  if(!sandbox&&Date.now()<LAUNCH)return;
  if(!permitted()||sendingPick)return;
  try{if(localStorage.getItem(PICK+suffix))return;}catch{return;}
  sendingPick=true;
  try{if(await send('pick'))localStorage.setItem(PICK+suffix,'1');}catch{}
  finally{sendingPick=false;}
 }
 async function checkPending(){
  let pending;
  try{pending=JSON.parse(sessionStorage.getItem(PENDING+suffix)||'null');}catch{}
  if(!pending)return;
  try{
   sessionStorage.removeItem(PENDING+suffix);
   if(Date.now()-pending.at>120000)return;
   const response=await fetch((window.Shopify?.routes?.root||'/')+'cart.js',{credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(4000)});
   if(!response.ok)return;
   const cart=await response.json();
   const quantity=cart.items.filter(x=>String(x.variant_id)===pending.variant).reduce((n,x)=>n+x.quantity,0);
   if(quantity>pending.before)await pick();
  }catch{}
 }
 async function start(){
  if(!permitted()||started||document.hidden)return;
  started=true;
  const recorded=await send('visit');
  document.documentElement.dataset.scActivityTracking=recorded?'visit-recorded':'visit-unavailable';
  await checkPending();
 }
 document.addEventListener('cart:update',event=>{
  const data=event.detail?.data;
  if(data?.source==='product-form-component'&&!data.didError&&Number(data.itemCount)>0)pick();
 });
 document.addEventListener('submit',event=>{
  if(!permitted())return;
  try{
   const form=event.target;
   if(!(form instanceof HTMLFormElement))return;
   const action=new URL(form.action,location.origin);
   if(action.origin!==location.origin||!/\/cart\/add(?:\.js)?$/.test(action.pathname))return;
   const variant=String(new FormData(form).get('id')||'');
   if(!/^\d+$/.test(variant))return;
   sessionStorage.setItem(PENDING+suffix,JSON.stringify({variant,before:Number(config.cart?.[variant]||0),at:Date.now()}));
  }catch{}
 },true);
 document.addEventListener('visitorConsentCollected',()=>{if(permitted())start();});
 document.addEventListener('visibilitychange',()=>{if(!document.hidden)start();});
 document.documentElement.dataset.scActivityTracking='waiting-for-consent';
 if(window.Shopify?.customerPrivacy)start();
 else window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)start();});
}
